module.exports = __webpack_public_path__ + "img/grid-2.53f265c6.svg";